import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated" 
import { ALIGN, LANDING_TYPE_CONTENT } from "../interfaces";
import { getID } from "src/libs/utilities";

export default function testinomials():any[] {
    return [
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.TESTINOMIALS,
          "vertical_align": ALIGN.FULL,
          "feedType": "carousel", 
          "border_radius": 20,
          "order": [ "speech_bubble", "person" ],
          "gap": 10,
          "columns": 2,
          "animated": "fadeInRight",
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "style": { "backgroundSize": 45, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
              "id": getID("iconMedallion"),
              "radius": 100,
              "margin": 25,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "speech_bubble": {
              "id": getID("speech_bubble"),
              "strokeWidth": 5, 
              "height": 180,
              "data": { "id": getID("speech_bubble"),"type": "html", "height": 160, "width": "100%" }
            },
            "person": {
              "id": getID(""),
              "avatarWidth": 75,
              "avatarHeight": 75,
              "border": { "borderWidth": 1, "borderRound": { "border": "50%" } }
            },
            "checkbox": {
              "id": getID(""),
              "style": { "padding": "10px 30px" }
            },
            "button": {
              "id": getID(""),
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider": { "id": getID(""), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Макади-бей – красивый залив в 30 км к югу от аэропорта Хургады, на берегу которого вырос туристический городок Макади "
                }
              },
              "person": {
                "id": getID(""),
                "user": {
                  "id": getID(""),
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "last_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg",
                  "description": "Бабочка на шее"
                }
              }
            },
            {
              "id": getID(""),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Луксор часто называют самым большим в мире музеем под открытым небом. Количество и сохранность памятников в районе Луксора не имеет аналогов нигде в мире."
                }
              },
              "person": {
                "id": getID(""),
                "user": {
                  "id": getID(""),
                  "display_name": "Мю Жасмин Геннадиевна",
                  "first_name": "Мю",
                  "last_name": "Жасмин Геннадиевна",
                  "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg",
                  "description": "Менеджер по персоналу «Деревня дураков»"
                }
              }
            },
            {
              "id": getID(""),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Красная пирамида и пирамида с ломаными гранями – вы слыхали о таких? Нет? Или слышали что-то, но не очень хорошо представляете себе, где они находятся?"
                }
              },
              "person": {
                "id": getID(""),
                "user": {
                  "id": getID(""),
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "last_name": "Савва Шехерезадович",
                  "description": "Старичок из «Macron inc.»",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            {
              "id": getID(""),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Какой же курорт выбрать и чем они отличаются? На материковой части расположены такие доступные курорты, как Эль-Гуна (El Gouna), Хургада (Hurghada), Макади Бей (Makadi Bay) и Сома Бей (Soma Bay), Сафага (Safaga), Эль Кузейр (El Quseir)/Марса Алам (Marsa Alam), Hamata/Berenice."
                }
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name--": "Бри Ларссон",
                  "first_name": "Ларссон",
                  "last_name": "Бри",
                  "avatar": "https://i.pinimg.com/736x/b0/5a/60/b05a60364221f39b3a474c3fb6fdd266.jpg",
                  "description": "Старичок из Сен-Дени"
                }
              }
            }
          ],
          "style": {},
          "defaultTitle": "Отзыв с прозрачным бабблом"
        },
        {
          "id": getID("features_cards"),
          "type": LANDING_TYPE_CONTENT.TESTINOMIALS,
          "vertical_align": ALIGN.FULL,
          "feedType": "carousel", 
          "border_radius": 20,
          "order": [ "speech_bubble", "person" ],
          "gap": 10,
          "columns": 2,
          "animated": "fadeInRight",
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "style": { "backgroundSize": 45, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
              "id": getID("iconMedallion"),
              "radius": 100,
              "margin": 25,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "speech_bubble": {
              "id": getID("speech_bubble"),
              "strokeWidth": 5,
              "background": "var(--force-plain-color)",
              "height": 180,
              "data": { "id": getID("speech_bubble"),"type": "html", "height": 160, "width": "100%" }
            },
            "person": {
              "id": getID(""),
              "avatarWidth": 75,
              "avatarHeight": 75,
              "border": { "borderWidth": 1, "borderRound": { "border": "50%" } }
            },
            "checkbox": {
              "id": getID(""),
              "style": { "padding": "10px 30px" }
            },
            "button": {
              "id": getID(""),
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider": { "id": getID(""), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Макади-бей – красивый залив в 30 км к югу от аэропорта Хургады, на берегу которого вырос туристический городок Макади "
                }
              },
              "person": {
                "id": getID(""),
                "user": {
                  "id": getID(""),
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "last_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg",
                  "description": "Бабочка на шее"
                }
              }
            },
            {
              "id": getID(""),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Луксор часто называют самым большим в мире музеем под открытым небом. Количество и сохранность памятников в районе Луксора не имеет аналогов нигде в мире."
                }
              },
              "person": {
                "id": getID(""),
                "user": {
                  "id": getID(""),
                  "display_name": "Мю Жасмин Геннадиевна",
                  "first_name": "Мю",
                  "last_name": "Жасмин Геннадиевна",
                  "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg",
                  "description": "Менеджер по персоналу «Деревня дураков»"
                }
              }
            },
            {
              "id": getID(""),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Красная пирамида и пирамида с ломаными гранями – вы слыхали о таких? Нет? Или слышали что-то, но не очень хорошо представляете себе, где они находятся?"
                }
              },
              "person": {
                "id": getID(""),
                "user": {
                  "id": getID(""),
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "last_name": "Савва Шехерезадович",
                  "description": "Старичок из «Macron inc.»",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            {
              "id": getID(""),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "speech_bubble": {
                "id": getID("speech_bubble"),
                "data": {
                  "id": getID("speech_bubble"),
                  "text": "<p>Какой же курорт выбрать и чем они отличаются? На материковой части расположены такие доступные курорты, как Эль-Гуна (El Gouna), Хургада (Hurghada), Макади Бей (Makadi Bay) и Сома Бей (Soma Bay), Сафага (Safaga), Эль Кузейр (El Quseir)/Марса Алам (Marsa Alam), Hamata/Berenice."
                }
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name--": "Бри Ларссон",
                  "first_name": "Ларссон",
                  "last_name": "Бри",
                  "avatar": "https://i.pinimg.com/736x/b0/5a/60/b05a60364221f39b3a474c3fb6fdd266.jpg",
                  "description": "Старичок из Сен-Дени"
                }
              }
            }
          ],
          "style": {},
          "defaultTitle": "Отзывы с актуализированным бабблом"
        },
        {
          "id": getID("testinomials"),
          "type": LANDING_TYPE_CONTENT.TESTINOMIALS,
          "feedType": "carousel",
          "vertical_align": ALIGN.FULL,
          "border_radius": 8,
          "order": [
            "avatarMedallion",
            "user_name",
            "user_description",
            "description"
          ],
          "gap": 50,
          columns:3,
          "animated": ANIMATED_STYLE.FADE_IN_LEFT,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "after": "<div style='position:absolute; bottom: 0; right: calc(50% - 50px); border: 12px solid transparent; border-left: 12px solid var(--force-contast-color); border-bottom: 12px solid var(--force-contast-color);'></div>",
          "card_fields": {
            "avatar": {
               "id": getID("avatar"), "style": { "backgroundSize": 70, "backgroundRepeat": "no-repeat" }
            },
            "avatarMedallion": {
               "id": getID("avatarMedallion"), 
               "radius": 100,
              "margin": 1,
              "borderRadius": 50,
              "style": {
                "backgroundColor": "var(--force-contast-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000066"
              }
            },
            "user_name": { "id": getID("user_name"), "style": { "fontWeight": 100, "paddingBottom": 0 } },
            "user_description": {
              "id": getID("user_description"), 
              "style": {
                "marginBottom": 12,
                "fontSize": "0.9em",
                "fontWeight": 100,
                "fontFamily": "Open Sans"
              }
            },
            "description": {
              "id": getID("description"), 
              "strokeWidth": 2,
              "style": { "boxShadow": "0 7px 5px 0px #00000012" },
              "data": { "type": "html", "className": "py-2 px-3" }
            },
            "button": {
              "id": getID("button"), 
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider": { "id": getID("avatar"), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"), 
              "user_name": { "id": getID("user_name"), "data": "Драгомил Люциферович Малфин" },
              "user_description": { "id": getID("user_description"), "data": "брэнд «Мир бровей»" },
              "description": {
                "id": getID("description"), 
                "data": "<p>Макади-бей – красивый залив в 30 км к югу от аэропорта Хургады, на берегу которого вырос туристический городок Макади со своей инфраструктурой, где уже около десятка отелей, расположенных рядом друг с другом. Здесь есть общие торговые центры, дискотеки и оздоровительные клубы. Пляжи в Макади все достаточно большие, песчаные (песок с большим количеством ракушек), заход в море в некоторых местах осложнен наличием на дне мертвых кораллов, небольших камней и ракушек. В некоторых местах для купания рекомендуется специальная обувь (можно купить в местных магазинчиках - 5-7 $ за пару), но не обязательна. Два коралловых рифа: один прямо напротив пляжа (около 70-и метров от берега), до одного можно дойти пешком - по косе (перпендикулярно морю). В отелях Sunrise Royal Makadi Resort 5*, Prima Life Makadi Resort*5 есть водные горки. Подробнее об отелях смотрите здесь: http://www.otzyv.ru/country.php?id=eg&city=7"
              },
              "avatarMedallion": {
                "id": getID("avatarMedallion"), 
                "data": "https://i.pinimg.com/1200x/5e/6e/a1/5e6ea1f2c3941d4a394f098bddbb2171.jpg"
              }
            },
            {
              "id": getID("card"), 
              "user_name": { "id": getID("user_name"), "data": "Максим Муслимович Врыжину" },
              "user_description": {
                "id": getID("user_description"), 
                "data": "комания «Наркоманов». Менеджер по персоналу"
              },
              "description": {
                "id": getID("description"), 
                "data": "<p>Луксор часто называют самым большим в мире музеем под открытым небом. Количество и сохранность памятников в районе Луксора не имеет аналогов нигде в мире. Сказать, что Луксор в Египте является главным центром притяжения для туристов, было бы приуменьшением. Он был туристическим центром всегда. Даже во времена греческого и римского периодов, Луксор привлекал туристов со всего света, что он и делает до сих пор. <p>Но сегодня Луксор конечно гораздо лучше приспособлен для обслуживания увеличившихся потоков туристов, которые стремятся в эту область нильской долины каждый год. Здесь особенно сильно чувствуется древность египетской земли, и словно оживают предания и легенды, ведь буквально под каждым домом города - фундаменты древних храмов и дворцов, аллеи сфинксов и фрагменты статуй."
              },
              "avatarMedallion": {
                "id": getID("avatarMedallion"), 
                "data": "https://i.pinimg.com/1200x/79/93/3b/79933be08f63b601bf997a83b17fda28.jpg"
              }
            },
            {
              "id": getID("card"), 
              "user_name": { "id": getID("user_name"), "data": "Буцефал Придорожский" },
              "user_description": { "id": getID("user_description"), "data": "дед-пердед" },
              "description": {
                "id": getID("description"), 
                "data": "<p>Красная пирамида и пирамида с ломаными гранями – вы слыхали о таких? Нет? Или слышали что-то, но не очень хорошо представляете себе, где они находятся? А между тем, это интереснейшие из пирамид, виденных мною в Египте! Впервые я увидела их неясные очертания на горизонте, когда была в Саккаре в 2005-м году. Оттуда, если подняться на южную стену, окружающую ступенчатую пирамиду Джоссера, и посмотреть дальше на юг, можно увидеть две пирамиды: одну пониже – красноватую, а другую повыше – с ломаными гранями. Я знаю, что до Саккары добираются многие туристы. Сама я побывала там первый раз вместе с экскурсией. А вот дальше почти никто не ездит, и очень зря. Тем более, что ехать, как оказалось, не так уж и далеко."
              },
              "avatarMedallion": {
                "id": getID("avatarMedallion"), 
                "data": "https://i.pinimg.com/1200x/ac/0e/3b/ac0e3b5b1cc14e84288c14f65882c7fc.jpg"
              }
            },
            {
              "id": getID("card"), 
              "user_name": { "id": getID("user_name"), "data": "Рада Сысовна Фигня" },
              "user_description": { "id": getID("user_description"), "data": "АО «Усцы»" },
              "description": {
                "id": getID("description"), 
                "data": "<p>Какой же курорт выбрать и чем они отличаются? На материковой части расположены такие доступные курорты, как Эль-Гуна (El Gouna), Хургада (Hurghada), Макади Бей (Makadi Bay) и Сома Бей (Soma Bay), Сафага (Safaga), Эль Кузейр (El Quseir)/Марса Алам (Marsa Alam), Hamata/Berenice. На Синайском полуострове – Шарм-эль-Шейх (Sharm El Sheikh), Дахаб (Dahab), Нувейба (Nuweiba), Таба (Taba)."
              },
              "avatarMedallion": {
                "id": getID("avatarMedallion"), 
                "data": "https://i.pinimg.com/736x/1b/32/15/1b321524a00954f087c7025403b5a12c.jpg"
              }
            }
          ],
          "style": {
            "paddingBottom": "45px",
            "marginBottom": 2,
            "marginRight": 2,
            "marginLeft": 2
          },
          "border": {
            "strokeWidth": 1,
            "stroke": "var(--force-contast-color)",
            "borderType": "nose",
            "noseDistination": "right"
          },
          defaultTitle: "Карусель. Медальон сверху"
        },
        {
          "id": getID("testinomilas"),
          "type": LANDING_TYPE_CONTENT.TESTINOMIALS,
          "vertical_align": ALIGN.FULL, 
          "feedType": "feed",
          "border_radius": 3,
          "order": ["description", "person"],
          "gap": 40,
          "columns": 2,
          "animated": "fadeInRight",
          "back_color": "var(--force-plain-color)",
          "card_fields": {
            "icon": {
              "id": getID(""),
              "style": { "backgroundSize": 45, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
              "id": getID("iconMedallion"),
              "radius": 100,
              "margin": 25,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "description": { 
                "id": getID("description"),
                "type": "description",
                "height": 160,
                "width": "100%",
                "style" : {
                  "paddingTop": 20
                }
            },
            "person": {
              "id": getID("person"),
              "avatarWidth": 75,
              "avatarHeight": 75,
              "border": { "borderWidth": 1, "borderRound": { "border": "50%" } },
              "style" : {
                "paddingBottom": 20
              }
            },
            "checkbox": {
              "id": getID("checkbox"),
              "style": { "padding": "10px 30px" }
            },
            "button": {
              "id": getID(""),
              "style": {
                "height": "auto",
                "padding": "20px",
                "paddingBottom": "auto"
              }
            },
            "divider": { "id": getID(""), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "description": {
                  "id": getID("description"),
                  "data": "<p>Макади-бей – красивый залив в 30 км к югу от аэропорта Хургады, на берегу которого вырос туристический городок Макади " 
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "last_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg",
                  "description": "Бабочка на шее"
                }
              }
            },
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "description": {
                  "id": getID("description"),
                  "data": "<p>Луксор часто называют самым большим в мире музеем под открытым небом. Количество и сохранность памятников в районе Луксора не имеет аналогов нигде в мире."
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name": "Мю Жасмин Геннадиевна",
                  "first_name": "Мю",
                  "last_name": "Жасмин Геннадиевна",
                  "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg",
                  "description": "Менеджер по персоналу «Деревня дураков»"
                }
              }
            },
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "description": {
                  "id": getID("description"),
                  "data": "<p>Красная пирамида и пирамида с ломаными гранями – вы слыхали о таких? Нет? Или слышали что-то, но не очень хорошо представляете себе, где они находятся?"
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "last_name": "Савва Шехерезадович",
                  "description": "Старичок из «Macron inc.»",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              }
            },
            {
              "id": getID("iconMedallion"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "description": {
                  "id": getID("description"),
                  "data": "<p>Какой же курорт выбрать и чем они отличаются? На материковой части расположены такие доступные курорты, как Эль-Гуна (El Gouna), Хургада (Hurghada), Макади Бей (Makadi Bay) и Сома Бей (Soma Bay), Сафага (Safaga), Эль Кузейр (El Quseir)/Марса Алам (Marsa Alam), Hamata/Berenice."
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name--": "Бри Ларссон",
                  "first_name": "Ларссон",
                  "last_name": "Бри",
                  "avatar": "https://i.pinimg.com/736x/b0/5a/60/b05a60364221f39b3a474c3fb6fdd266.jpg",
                  "description": "Старичок из Сен-Дени"
                }
              }
            }
          ],
          "style": {},
          "defaultTitle": "Карточки в 2 колонки"
        },
        {
         "id": getID("testinomilas"),
          "type": LANDING_TYPE_CONTENT.TESTINOMIALS,
          "vertical_align": ALIGN.FULL,  
          "carousel_nav": "square",
          "height": 510,
          "carousel_nav_size": "large",
          "carousel_nav_theme": "red",
          "carousel_nav_type": "long-arrow-alt",
          "carousel_nav_position": "middle-outer-",
          "feedType": "carousel",
          "order": ["person", "description", "buttons"],
          "columns": 1,
          "animated": "fadeInRight",
          "card_fields": {
            "icon": {
              "id": getID("icon"),
              "style": { "backgroundSize": 45, "backgroundRepeat": "no-repeat" }
            },
            "iconMedallion": {
              "id": getID(""),
              "radius": 100,
              "margin": 25,
              "style": {
                "backgroundColor": "var(--force-plain-color)",
                "border": "1px solid var(--force-mini-contast-color)",
                "boxShadow": "0 7px 5px 0px #00000012"
              }
            },
            "title": {
              "id": getID("title"),
              "style": {
                "fontWeight": 100,
                "fontSize": 18,
                "textTransform": "uppercase"
              }
            },
            "person": {
              "id": getID("person"),
              "avatarWidth": 150,
              "avatarHeight": 150,
              "isVertical": true,
              "border": {
                "borderWidth": 1,
                "borderRound": { "border": "50%" }
              },
              "style": { "paddingBottom": 20 }
            },
            "description": {
              "id": getID("description"),
              "type": "description",
              "height": 160,
              "width": "100%",
              "style": { "fontSize": 20, "fontWeight": 100, "paddingTop": 20 }
            },
            "checkbox": {
              "id": getID(""),
              "style": { "padding": "10px 30px" }
            },
            "buttons": {
              "id": getID("buttons"),
              "design_type": "round",
              "button_color": "red",
              "border_width": 2,
              "style": {
                "height": 40,
                "width": 360,
                "paddingLeft": 30,
                "paddingRight": 30,
                "fontWeight": 700,
                "textTransform": "uppercase",
                "fontSize": 15
              }
            },
            "divider": { "id": getID(""), "divider_height": "0px" }
          },
          "cards": [
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name": "Кукушечкова Алевтина Исаевна",
                  "first_name": "Кукушечкова",
                  "last_name": "Алевтина Исаевна",
                  "avatar": "https://i.pinimg.com/1200x/c3/d2/23/c3d2239b2d538d358b6a6f8cb41064a0.jpg",
                  "description": "Бабочка на шее"
                }
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Макади-бей – красивый залив в 30 км к югу от аэропорта Хургады, на берегу которого вырос туристический городок Макади "
              },
              "buttons": { "id": getID("buttons"), "buttons": [{ "label": "Подробнее", "url": "" }] }
            },
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name": "Мю Жасмин Геннадиевна",
                  "first_name": "Мю",
                  "last_name": "Жасмин Геннадиевна",
                  "avatar": "https://i.pinimg.com/736x/81/29/68/812968d40c40bcd574c89953ed585fad.jpg",
                  "description": "Менеджер по персоналу «Деревня дураков»"
                }
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Луксор часто называют самым большим в мире музеем под открытым небом. Количество и сохранность памятников в районе Луксора не имеет аналогов нигде в мире."
              },
              "buttons": { "id": getID("buttons"), "buttons": [{ "label": "Подробнее", "url": "" }] }
            },
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name--": "Сигизмундов Савва Шехерезадович",
                  "first_name": "Сигизмундов",
                  "last_name": "Савва Шехерезадович",
                  "description": "Старичок из «Macron inc.»",
                  "avatar": "https://i.pinimg.com/1200x/8e/60/41/8e604177b55ebe1ad8ed9a6f242c2fb1.jpg"
                }
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Красная пирамида и пирамида с ломаными гранями – вы слыхали о таких? Нет? Или слышали что-то, но не очень хорошо представляете себе, где они находятся?"
              },
              "buttons": {
                "id": getID("buttons"),
                "design_type": "round_outline",
                "button_color": "darkgeen",
                "border_width": 4,
                "buttons": [{ "label": "Подробнее", "url": "" }]
              }
            },
            {
              "id": getID("card"),
              "iconMedallion": {
                "id": getID("iconMedallion"),
                "data": "https://cdn-icons-png.flaticon.com/128/10750/10750959.png"
              },
              "person": {
                "id": getID("person"),
                "user": {
                  "id": getID("person"),
                  "display_name--": "Бри Ларссон",
                  "first_name": "Ларссон",
                  "last_name": "Бри",
                  "avatar": "https://i.pinimg.com/736x/b0/5a/60/b05a60364221f39b3a474c3fb6fdd266.jpg",
                  "description": "Старичок из Сен-Дени"
                }
              },
              "description": {
                "id": getID("description"),
                "data": "<p>Какой же курорт выбрать и чем они отличаются? На материковой части расположены такие доступные курорты, как Эль-Гуна (El Gouna), Хургада (Hurghada), Макади Бей (Makadi Bay) и Сома Бей (Soma Bay), Сафага (Safaga), Эль Кузейр (El Quseir)/Марса Алам (Marsa Alam), Hamata/Berenice."
              },
              "buttons": { "id": getID("buttons"), "buttons": [{ "label": "Подробнее", "url": "" }] }
            }
          ],
          "style": {},
          "defaultTitle": "Карусель. Большой круглый аватар"
        }
    ]
}